<!-- src/lib/components/BusyIndicator.svelte -->
<script>
	import { busy } from '$lib/busy.svelte';
</script>

<div
	class="pointer-events-none fixed inset-0 z-9999 flex items-center justify-center bg-black/30 opacity-0
         transition-opacity duration-300"
	class:opacity-100={$busy}
	class:pointer-events-auto={$busy}
>
	<div
		class="h-12 w-12 animate-spin rounded-full border-[5px] border-gray-300 border-t-teal-700"
	></div>
</div>
